import type { CryptoTransactionFilters } from '../types/cryptoWalletTypes'

export const cryptoWalletKeys = {
  all: ['cryptoWallet'] as const,
  wallet: () => [...cryptoWalletKeys.all, 'wallet'] as const,
  transactionLists: () => [...cryptoWalletKeys.all, 'transactions'] as const,
  transactionList: (filters: CryptoTransactionFilters) =>
    [...cryptoWalletKeys.transactionLists(), filters] as const,
}
